export default function InputField({
    id,
    label,
    min,
    max,
    type = 'text',
    placeholder = '',
    value,
    onChange,
    required = false,
    disabled = false,
    error,
    uppercase = false,  
    ...rest          
}) {
    return (
        <div className="mb-3">
            <label htmlFor={id} className="form-label">
                {label}{required && ' *'}
            </label>
             
            <input
                id={id}
                type={type}
                className={`form-control ${error ? 'is-invalid' : ''} ${uppercase ? 'uppercase-input' : ''}`}
                placeholder={placeholder}
                min={min}
                max={max}
                value={value || ''}
                onChange={e => {
                    const val = uppercase ? e.target.value.toUpperCase() : e.target.value;
                    onChange(id, val);
                }}
                required={required}
                disabled={disabled}
                {...rest}
            /> 
            {error && (
                <div className="invalid-feedback">
                    {Array.isArray(error) ? error[0] : error}
                </div>
            )}
        </div>
    );
}
